module.exports = __webpack_public_path__ + "static/img/label02.770f9b40.png";